import React , { useRef, useState } from 'react';
import emailjs from '@emailjs/browser';

import './styling/Contact.css'; // Don't forget to create your CSS file for styling
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp} from '@fortawesome/free-brands-svg-icons';
import { faPhone, faMapMarkerAlt, faEnvelope, faMobile} from '@fortawesome/free-solid-svg-icons';
import logoimg from './styling/images/logo.png'

const Contact = () => {

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });
  const [notificationVisible, setNotificationVisible] = useState(false);
  const form = useRef();

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    sendEmail(e);
  };
  // variables in the form of emailjs

  const sendEmail = (e) => {
    emailjs
      .sendForm(
        'service_b0rzwka', 
        'template_e4gn4fm', 
        form.current, {
        publicKey: 'KtU8wOP2uaYJ1rNmu',
      })
      .then(
        (result) => {
          setNotificationVisible(true);
          setTimeout(() => setNotificationVisible(false), 3000); // Hide after 3 seconds
          
          // Reset the form fields
          e.target.reset();
        })
        .catch(() => alert('Failed to send message, try again later.'));


  };
  return (
    <div className="contact-page">
      <div className='contact-info'>
        <div className='logo'>
          <img src={logoimg}  alt="Logo"/>
        </div>

        <p> 
        <FontAwesomeIcon icon={faMapMarkerAlt} className="contact_icon" />
          <b>Address:</b> G-09, Odeon Centre, Regal Saddar, Karachi
          </p>
          
        <p>
          
        <FontAwesomeIcon icon={faPhone} className="contact_icon" />
          <b>Phone:</b> +92 21 32734269</p> 
          
          <p> 
            
          <FontAwesomeIcon icon={faMobile}  className="contact_icon"/>
            <b>Mobile
              / 
          <FontAwesomeIcon icon={faWhatsapp}  className="contact_icon"/>
              WhatsApp:</b> +92 333 2113055, +92 335 2929894 </p>
          
          <p>
            
          <FontAwesomeIcon icon={faEnvelope} className="contact_icon"/>
            <b>Email:</b> arosepowertechnologies@outlook.com, business@arosepowertechnologies.com</p>
      <div/>
<div className='contact-container'>
      <div className="map">
        <iframe 
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3620.0939758570853!2d67.02258987442968!3d24.860639745252218!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3eb33f8ad3e4146f%3A0x7272294962dbe1cf!2sODEON%20CENTRE!5e0!3m2!1sen!2s!4v1705315231347!5m2!1sen!2s" 
        width="1000"
        height="500" 
        allowfullscreen="" 
        loading="lazy"  
        referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div> 
      <div className="contact-form">
        <h2>Contact Us</h2>
        <form ref={form} onSubmit={handleSubmit}>
          <label htmlFor="name">Name:<div className='r'>*</div></label>
          <input type="text" id="name" onChange={handleChange} name="user_name" required />

          <label htmlFor="email">Email:<div className='r'>*</div></label>
          <input type="email" id="email" onChange={handleChange} name="user_email" required />

          <label htmlFor="message">Message:<div className='r'>*</div></label>
          <textarea id="message" onChange={handleChange} name="message" required></textarea>

          <button type="submit">Send Message</button>
        </form>
         {/* Simple Notification */}
      <div className={`notification ${notificationVisible ? 'show' : ''}`}>
        Message sent successfully!
      </div>
      </div>

      
    </div>
    </div>
    </div>
  );
};
export default Contact;
